import { USER_FEEDBACK } from "../APIErrors";
import { CreatePaymentResponseDto, CreatePaymentResponseDtoSchema } from "./netsEasyAPISchema";
import { LogErrorResponse } from "../Logging/LoggingAPI";

const API_URL = "/api/payment/netseasy";

export const createPayment = async (): Promise<CreatePaymentResponseDto> => {
    const url = `${API_URL}/create-payment`;
    const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
        },
    });

    if (!response.ok) {
        await LogErrorResponse(url, response);
        return Promise.reject(USER_FEEDBACK.GENERIC);
    }

    const data = await response.json();
    const validatedObject = CreatePaymentResponseDtoSchema.parse(data);

    return validatedObject;
};
